<mat-dialog-content>
  <p>
    {{ message }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="secondary-btn" (click)="onConfirmClick()" tabindex="1">
    {{ confirmButtonText }}
  </button>
  <button mat-dialog-close tabindex="-1" class="primary-btn ml-2">
    {{ cancelButtonText }}
  </button>
</mat-dialog-actions>
